import { buildModelManager } from "../builder.js";
const DefaultPreceptorSelection = {
  __typename: true,
  id: true,
  agencyId: true,
  availability: true,
  averageScore: true,
  carrier: true,
  createdAt: true,
  createdById: true,
  department: true,
  email: true,
  employeeId: true,
  evaluationHistory: true,
  firstName: true,
  isActive: true,
  lastEvaluationDate: true,
  lastName: true,
  lastTrainingCompletedAt: true,
  licenseExpiration: true,
  licenseNumber: true,
  maxStudentsPerShift: true,
  notes: { markdown: true, truncatedHTML: true },
  overallRating: true,
  performanceMetrics: true,
  phoneNumber: true,
  preferredShiftTypes: true,
  primaryCertification: true,
  secondaryCertifications: true,
  specialties: true,
  totalEvaluations: true,
  trainingCertificationNumber: true,
  trainingExpiresAt: true,
  trainingNotes: true,
  trainingRequiredBy: true,
  trainingStatus: true,
  updatedAt: true,
  userId: true,
  yearsExperience: true
};
const modelApiIdentifier = "preceptor";
const pluralModelApiIdentifier = "preceptors";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPreceptorSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPreceptorSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPreceptorSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPreceptorSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPreceptorSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPreceptorSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPreceptorSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByEmployeeId",
    findByField: "employeeId",
    findByVariableName: "employeeId",
    modelApiIdentifier,
    defaultSelection: DefaultPreceptorSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByEmployeeId",
    findByField: "employeeId",
    findByVariableName: "employeeId",
    modelApiIdentifier,
    defaultSelection: DefaultPreceptorSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByEmail",
    findByField: "email",
    findByVariableName: "email",
    modelApiIdentifier,
    defaultSelection: DefaultPreceptorSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByEmail",
    findByField: "email",
    findByVariableName: "email",
    modelApiIdentifier,
    defaultSelection: DefaultPreceptorSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createPreceptor",
    operationReturnType: "CreatePreceptor",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { preceptor: { required: false, type: "CreatePreceptorInput" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPreceptorSelection
  },
  {
    type: "action",
    operationName: "bulkCreatePreceptors",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreatePreceptorsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPreceptorSelection
  },
  {
    type: "action",
    operationName: "updatePreceptor",
    operationReturnType: "UpdatePreceptor",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      preceptor: { required: false, type: "UpdatePreceptorInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPreceptorSelection
  },
  {
    type: "action",
    operationName: "bulkUpdatePreceptors",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdatePreceptorsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPreceptorSelection
  },
  {
    type: "action",
    operationName: "deletePreceptor",
    operationReturnType: "DeletePreceptor",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeletePreceptors",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertPreceptor",
    operationReturnType: "UpsertPreceptor",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      preceptor: { required: false, type: "UpsertPreceptorInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreatePreceptorResult": { hasReturnType: false },
      "... on UpdatePreceptorResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPreceptorSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertPreceptors",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertPreceptorsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultPreceptorSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "preceptorGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const PreceptorManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultPreceptorSelection,
  operations
);
export {
  DefaultPreceptorSelection,
  PreceptorManager
};
//# sourceMappingURL=Preceptor.js.map
